import { Box, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const DoodleJump = () => {
    const navigate = useNavigate()

    const desgin = {
        width: '100%',
        margin: 'auto',
        height: '100vh',
        overflow: 'hidden',
    }


    return (
        <Box bg={['white','linear-gradient(30deg, rgb(0, 7, 61), rgb(0, 10, 63), rgb(0, 13, 66), rgb(0, 16, 68), rgb(0, 19, 71), rgb(0, 22, 73), rgb(0, 25, 76), rgb(0, 28, 78), rgb(0, 31, 80), rgb(0, 34, 83), rgb(0, 37, 85), rgb(0, 40, 88), rgb(0, 43, 90), rgb(0, 46, 92), rgb(0, 49, 95), rgb(0, 52, 97), rgb(0, 55, 100), rgb(0, 58, 102), rgb(0, 61, 105), rgb(0, 64, 107))','linear-gradient(30deg, rgb(0, 7, 61), rgb(0, 10, 63), rgb(0, 13, 66), rgb(0, 16, 68), rgb(0, 19, 71), rgb(0, 22, 73), rgb(0, 25, 76), rgb(0, 28, 78), rgb(0, 31, 80), rgb(0, 34, 83), rgb(0, 37, 85), rgb(0, 40, 88), rgb(0, 43, 90), rgb(0, 46, 92), rgb(0, 49, 95), rgb(0, 52, 97), rgb(0, 55, 100), rgb(0, 58, 102), rgb(0, 61, 105), rgb(0, 64, 107))']}>
            <Heading onClick={() => navigate(-1)} cursor={'pointer'} color={['black','transparent','transparent']} fontWeight={'medium'} fontSize={['17px','24px','27px']} position={'fixed'} padding={'10px'} style={{ backgroundImage: 'linear-gradient(30deg, rgb(0, 170, 255), rgb(1, 279, 16))', WebkitBackgroundClip: 'text', backgroundClip: 'text', }}>||| Dooble Jump</Heading>

            <Box w={['100%', '455px', '455px']} m={'auto'}>
                <iframe style={desgin} sandbox="allow-same-origin allow-scripts allow-popups" src="https://6548ccdb30cd2a1119448ad9--stunning-shortbread-e16a31.netlify.app/"></iframe>
            </Box>
        </Box>
    )
}
